document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.roseaux-card-form');

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const submitButton = form.querySelector('[name="add"]');
      const select = form.querySelector('select[name="id"]');

      if (select && !select.value) {
        select.focus();
        return;
      }

      const originalText = submitButton.textContent;
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';

      try {
        const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Unable to add product');
        }

        await response.json();

        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        updateRoseauxCartCount(cart.item_count);

        submitButton.textContent = 'Added ✓';

        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 1200);

      } catch (error) {
        console.error(error);

        submitButton.textContent = 'Try Again';

        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 1500);
      }
    });
  });

  function updateRoseauxCartCount(count) {
    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = `
          <span aria-hidden="true"></span>
          <span class="visually-hidden"></span>
        `;
        cartIcon.appendChild(bubble);
      }

      const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenCount = bubble.querySelector('.visually-hidden');

      if (visibleCount) {
        visibleCount.textContent = count < 100 ? count : '99+';
      }

      if (hiddenCount) {
        hiddenCount.textContent = `${count} items`;
      }
    } else if (bubble) {
      bubble.remove();
    }
    const compactBubble = document.querySelector('.roseaux-compact-cart-count');

if (compactBubble) {
  const compactVisibleCount = compactBubble.querySelector(
    'span[aria-hidden="true"]'
  );

  if (compactVisibleCount) {
    compactVisibleCount.textContent = count < 100 ? count : '99+';
  }

  compactBubble.classList.toggle('is-empty', count <= 0);
}
  }
});